var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSm = function SvgIconSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12c.522 0 12-1.565 12-1.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M16.763 8.28 12 13.045 7.237 8.281a5.7 5.7 0 0 0-.976 3.198v1.565a5.75 5.75 0 0 0 3.877 5.43c-.3.589-.25 1.324.191 1.874l1.706-1.366 1.705 1.366a1.74 1.74 0 0 0 .18-1.896 5.75 5.75 0 0 0 3.819-5.408v-1.565c0-1.183-.36-2.284-.976-3.198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 17.217a4.18 4.18 0 0 1-4.174-4.173v-1.566A4.18 4.18 0 0 1 12 7.304a4.18 4.18 0 0 1 4.174 4.174v1.566A4.18 4.18 0 0 1 12 17.217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M14.609 13.043v-1.565A2.61 2.61 0 0 0 12 8.87a2.61 2.61 0 0 0-2.608 2.61v1.564l2.608.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M9.392 13.043A2.61 2.61 0 0 0 12 15.652a2.61 2.61 0 0 0 2.609-2.609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M15.13 7.304a1.565 1.565 0 0 0-2.609-1.166v-.92h.522V4.173h-.522v-.522h-1.043v.522h-.522v1.043h.522v.92A1.565 1.565 0 0 0 9.39 8.47v.921h5.217v-.92c.32-.287.522-.704.522-1.167"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSm;